import React from "react";
import PatientListContainer from "containers/PatientListContainer";

const PatientList = () => {
    return <PatientListContainer />;
};

export default PatientList;
